import { Container, Grid, Link, Typography } from "@octopus-energy/coral/atoms"
import { FooterList } from "@octopus-energy/coral/organisms"
import { useTranslations } from "next-intl"
import { useOfficeAddress } from "@/features/addresses"
import { type PartnerLinks } from "../types/partnerLink"

const FOOTER_WIDTH = 1140

interface PartnerFooterProps {
    links: PartnerLinks
    shouldDisplayPrivacyPolicy?: boolean
}

export function PartnerFooter({ links, shouldDisplayPrivacyPolicy = false }: PartnerFooterProps) {
    const t = useTranslations("PartnerFooter")
    const { fullAddress } = useOfficeAddress()

    const privacyPolicyLink = links.find((link) => link.key === "privacy-policy")?.href

    return (
        <Container
            fullWidth
            theme="base900"
            component="footer"
        >
            <Container
                fullWidth
                marginX="auto"
                maxWidth={FOOTER_WIDTH}
                paddingX={{ base: "md", sm: "lg", md: "lg" }}
                paddingY={{ base: "lg", sm: "xl", md: "xxl" }}
            >
                <Grid gap="sm">
                    {shouldDisplayPrivacyPolicy && (
                        <Typography textStyle="caption">
                            {t.rich("privacyPolicy", {
                                a: (chunks) => (
                                    <Link
                                        target="_blank"
                                        href={privacyPolicyLink}
                                    >
                                        {chunks}
                                    </Link>
                                ),
                            })}
                        </Typography>
                    )}
                    <Grid
                        gap="md"
                        justifyContent="left"
                    >
                        {links.map(({ label, key, ...linkProps }) => (
                            <FooterList key={key}>
                                <Link {...linkProps}>{label}</Link>
                            </FooterList>
                        ))}
                        <FooterList key="cookies">
                            <Link onClick={() => window?.Didomi?.preferences.show()}>Cookies</Link>
                        </FooterList>
                    </Grid>
                    <Grid gap="md">
                        <Typography textStyle="caption">
                            {t("office", { address: fullAddress })}
                        </Typography>
                        <Typography textStyle="caption">{t("saveEnergy")}</Typography>
                    </Grid>
                </Grid>
            </Container>
        </Container>
    )
}

PartnerFooter.messages = ["PartnerFooter"] as const
